import axios from 'axios';
import { 
  FETCHING_TRANSLATION_TABLES,
  FETCH_TRANSLATION_TABLES_SUCCESS,
  BACKUP_TRANSLATION_TABLES,
  RESTORE_TRANSLATION_TABLES,
  DELETE_UNCONFIRMED_TRANSLATION_TABLE
} from "./ProfileTranslationTablesConstants";

const fetchingTranslationTables = () => ({ type: FETCHING_TRANSLATION_TABLES });
const fetchTranslationTablesSuccess = translationTables => ({ type: FETCH_TRANSLATION_TABLES_SUCCESS, translationTables });
const backupTranslationTables = () => ({ type: BACKUP_TRANSLATION_TABLES });
const restoreTranslationTables = () => ({ type: RESTORE_TRANSLATION_TABLES });
const deleteUnconfirmedTranslationTable = ttId => ({ type: DELETE_UNCONFIRMED_TRANSLATION_TABLE, ttId });

const url = 'utm/v1/mapping';

const fetchTranslationTables = mapId => dispatch => {
  dispatch(fetchingTranslationTables());
  axios.get(`${url}/${mapId}/transl-tbls`)
    .then(tTablesResponse => {
      dispatch(fetchTranslationTablesSuccess(tTablesResponse.data.data));
    })
    .catch(error => {
      throw error;
    });
};

const deleteUnconfirmedTranslationTableFromList = ttId => dispatch => {
  dispatch(deleteUnconfirmedTranslationTable(ttId));
};

export {
  backupTranslationTables,
  restoreTranslationTables,
  fetchTranslationTables,
  deleteUnconfirmedTranslationTableFromList
};



// WEBPACK FOOTER //
// ./src/redux/profileTranslationTables/ProfileTranslationTablesActions.js